import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ACCREDITATION_LOGOS } from '../../data/siteContent'
import { PageSlugs } from '../../constants/pageSlugs'

export default function AccreditationsStrip() {
  const { t } = useTranslation()

  return (
    <section
      className="border-t border-border bg-white py-10 sm:py-12"
      aria-labelledby="home-accreditations-title"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
          <h2 id="home-accreditations-title" className="text-lg font-bold text-primary sm:text-xl">
            {t('homeAccreditations.title')}
          </h2>
          <Link
            to={`/pages/${PageSlugs.accreditations}`}
            className="text-sm font-semibold text-accent transition hover:text-primary"
          >
            {t('homeAccreditations.viewAll')}
          </Link>
        </div>

        <div className="-mx-1 overflow-x-auto pb-1 [scrollbar-width:thin] sm:mx-0 sm:overflow-visible sm:pb-0">
          <ul className="flex min-w-max items-center gap-5 px-1 sm:min-w-0 sm:w-full sm:justify-between sm:gap-3 sm:px-0">
            {ACCREDITATION_LOGOS.map((logo) => (
              <li
                key={logo.slug}
                className="flex h-14 w-[7rem] shrink-0 items-center justify-center sm:h-16 sm:w-auto sm:min-w-0 sm:flex-1"
              >
                <img
                  src={logo.image}
                  alt={logo.name}
                  className="max-h-12 w-auto max-w-full object-contain sm:max-h-14"
                  loading="lazy"
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  )
}
